<template>
  <v-app>
    <v-main>
      <loading
        v-model:active="isLoading"
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="true"
        background-color="#fff"
        :opacity="1"
      ></loading>
      <v-img
        :width="300"
        aspect-ratio="16/9"
        src="../../../assets/logo.png"
      ></v-img>
      <br />
      <div class="border-styling">
        {{ dtsVal }}
      </div>
    </v-main>
  </v-app>
</template>

<script>
/*eslint-disable*/
import { ref, onBeforeMount, watchEffect, watch, inject } from "vue";
import Loading from "vue-loading-overlay";
import VueCookies from "vue-cookies";
import { viewport } from "@popperjs/core";

export default {
  components: {
    Loading,
  },
  setup() {
    const isLoading = ref(false);
    const dtsVal = ref("");
    const http = ref(inject("http"));
    onBeforeMount(async () => {
      console.log("bfre async")
      isLoading.value = true;
      const urlParams = new URLSearchParams(window.location.search);
      const id = await urlParams.get("id");
      console.log("id", id);
      const apidata = {
        product_id: id,
      };
      console.log(apidata, "apidata");
      fetch(`${http.value.productdata}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(apidata),
        }
      ).then((response) => {
        response.json().then(async (data) => {
          //   productDeatilByProductIds.value = data;
          console.log("2data", data);
          dtsVal.value = data.dts_val;
          isLoading.value = false;
        });
      });
    });
    return {
      dtsVal,
      isLoading,
    };
  },
};
</script>
<style>
.border-styling {
  border-bottom: 1px solid blue;
  border-top: 1px solid blue;
  padding-bottom: 15px;
  padding-top: 15px;
  /* font-size: 0.85em; */
  font-weight: bold;
  font-family: "Times New Roman";
  color: #5d5d5d;
}
.v-container {
  min-width: 100%;
}
</style>
